import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { map } from 'rxjs';
import { OrganizationService } from 'src/app/@domain/organization/service/organization.service';

@Component({
    selector: 'app-organizations-section',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterLink, AsyncPipe],
    styles: `
        @use "variables" as *;

        :host {
            display: block;
            width: 100%;
        }

        .organizations-grid {
            display: flex;
            flex-wrap: wrap;
            gap: 0.75rem;
            align-items: flex-start;

            @media screen and (max-width: 768px) {
                display: grid;
                grid-template-rows: repeat(2, auto);
                grid-auto-flow: column;
                gap: 0.5rem;
                overflow-x: auto;
                overflow-y: hidden;
                -webkit-overflow-scrolling: touch;
                scrollbar-width: none;
                -ms-overflow-style: none;

                &::-webkit-scrollbar {
                    display: none;
                }
            }
        }

        .organization-btn {
            display: inline-block;
            padding: 0.65rem 1.5rem;
            background-color: $light-blue;
            color: $dark-blue;
            text-decoration: none;
            font-weight: 600;
            font-size: 16px;
            text-transform: uppercase;
            letter-spacing: 0.02em;
            border-radius: 4px !important;
            transition: background-color 200ms ease, color 200ms ease;
            white-space: nowrap;
            width: 256px;
            overflow: hidden;
            text-overflow: ellipsis;
            text-align: center;

            &:hover {
                background-color: $red;
                color: #fff;
            }

            @media screen and (max-width: 768px) {
                padding: 0.5rem 1rem;
                font-size: 14px;
            }
        }
    `,
    template: `
        <div class="organizations-grid">
            @for (organization of organizations$ | async; track organization.id) {
                <a class="organization-btn" [routerLink]="['/organizations', organization.id]" [title]="organization.name">
                    {{ organization.name }}
                </a>
            }
        </div>
    `
})
export class OrganizationsSectionComponent {
    private organizationService = inject(OrganizationService);
    
    public organizations$ = this.organizationService.getOrganizationsInfos().pipe(
        map(response => response.results.slice(0, 5))
    );
}
